import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VoicesRoutingModule } from './voices-routing.module';
import { VoicesComponent } from './voices.component';
import { VoiceService } from './voice.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DatatableModule } from 'src/app/shared/datatable/datatable.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { VoiceCoreService } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';
import { VoiceFormComponent } from './voice-form/voice-form.component';
import { AddVoiceComponent } from './add-voice/add-voice.component';
import { EditVoiceComponent } from './edit-voice/edit-voice.component';
import { CloneVoiceComponent } from './clone-voice/clone-voice.component';

@NgModule({
  declarations: [
    VoicesComponent,
    VoiceFormComponent,
    AddVoiceComponent,
    EditVoiceComponent,
    CloneVoiceComponent,
  ],
  imports: [
    CommonModule,
    VoicesRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    DatatableModule,
    SharedModule,
  ],
  providers: [VoiceService, VoiceCoreService],
})
export class VoicesModule {}
